import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class SharedServiceService {
  userLoggedIn = new EventEmitter<any>();
  userLoggedOut = new EventEmitter<any>();
  clientAdded = new EventEmitter<any>();
  addClient = new EventEmitter<any>();
  updated = new EventEmitter<any>();


  constructor() {
  }

  dispatchEmitter(type: string, data: any): void {
    this.updated.emit({type, data});
  }

  subscribeEmitter(): EventEmitter<any> {
    return this.updated;
  }
}
